import type { ISpecialityDescription } from './types'

export const AVAILABLE_SPECIALITIES: string[] = [
  'servicoAssistenteSocial',
  'servicoMedico',
  'servicoEnfermagem',
  'servicoPsicologia',
  'servicoNutricao',
  'servicoDentista',
  'servicoFisioterapeuta',
  'servicoFonoaudiologo',
  'servicoPsicologiaViva',
  'servicoEducadorFisico',
]

export const SPECIALITIES_DESCRIPTION_AMIL: ISpecialityDescription = {
  ASSISTENTE_SOCIAL: {
    title: 'Assistentes sociais',
    description: 'Para acolher e encaminhar ao especialista adequado.',
    cypressScheduleId: 'social-assistant-schedule',
    cypressImmediateId: 'social-assistant-immediate',
    cypressConsultationHelpId: 'social-assistant-consultation-help',
  },
  DENTISTA: {
    title: 'Dentistas',
    description:
      'Para garantir a saúde dos dentes, da gengiva e da higiene bucal.',
    cypressScheduleId: 'dentist-schedule',
    cypressImmediateId: 'dentist-immediate',
    cypressConsultationHelpId: 'dentist-consultation-help',
  },
  ENFERMEIRO: {
    title: 'Enfermeiros',
    description: 'Para orientar e acompanhar o tratamento do paciente.',
    cypressScheduleId: 'nurse-schedule',
    cypressImmediateId: 'nurse-immediate',
    cypressConsultationHelpId: 'nurse-consultation-help',
  },
  FISIOTERAPEUTA: {
    title: 'Fisioterapeutas',
    description: 'Para atuar na reabilitação física do paciente',
    cypressScheduleId: 'physiotherapist-schedule',
    cypressImmediateId: 'physiotherapist-immediate',
    cypressConsultationHelpId: 'physiotherapist-consultation-help',
  },
  FONOAUDIOLOGO: {
    title: 'Fonoaudiólogos',
    description:
      'Para ajudar a desenvolver a comunicação oral e escrita em crianças, jovens e adultos.',
    cypressScheduleId: 'speech-therapist-schedule',
    cypressImmediateId: 'speech-therapist-immediate',
    cypressConsultationHelpId: 'speech-therepist-consultation-help',
  },
  MEDICO: {
    title: 'Médicos',
    description: 'Para cuidar da saúde por completo com clínicos gerais.',
    cypressScheduleId: 'doctor-schedule',
    cypressImmediateId: 'doctor-immediate',
    cypressConsultationHelpId: 'doctor-consultation-help',
  },
  NUTRICIONISTA: {
    title: 'Nutricionistas',
    description: 'Para orientar sobre hábitos e alimentação saudáveis.',
    cypressScheduleId: 'nutritionist-schedule',
    cypressImmediateId: 'nutritionist-immediate',
    cypressConsultationHelpId: 'nutritionist-consultation-help',
  },
  PSICOLOGO: {
    title: 'Psicólogos',
    description: 'Para cuidar da saúde da mente e das emoções.',
    cypressScheduleId: 'psychologist-schedule',
    cypressImmediateId: 'psychologist-immediate',
    cypressConsultationHelpId: 'psychologist-consultation-help',
  },
  // PSICOLOGO_VIVA: '',
  EDUCADOR_FISICO: {
    title: 'Educador Físico',
    description: 'Para cuidar da saúde física e do bem-estar.',
    cypressScheduleId: 'physical-educator-schedule',
    cypressImmediateId: 'physical-educator-immediate',
    cypressConsultationHelpId: 'physical-educator-consultation-help',
  },
}

export const SPECIALITIES_DESCRIPTION: ISpecialityDescription = {
  ASSISTENTE_SOCIAL: {
    title: 'Assistentes sociais',
    description: 'Para acolher e encaminhar ao especialista adequado.',
    cypressScheduleId: 'social-assistant-schedule',
    cypressImmediateId: 'social-assistant-immediate',
    cypressConsultationHelpId: 'social-assistant-consultation-help',
  },
  DENTISTA: {
    title: 'Dentistas',
    description:
      'Para garantir a saúde dos dentes, da gengiva e da higiene bucal.',
    cypressScheduleId: 'dentist-schedule',
    cypressImmediateId: 'dentist-immediate',
    cypressConsultationHelpId: 'dentist-consultation-help',
  },
  ENFERMEIRO: {
    title: 'Enfermeiros',
    description: 'Para orientar e acompanhar o tratamento do paciente.',
    cypressScheduleId: 'nurse-schedule',
    cypressImmediateId: 'nurse-immediate',
    cypressConsultationHelpId: 'nurse-consultation-help',
  },
  FISIOTERAPEUTA: {
    title: 'Fisioterapeutas',
    description: 'Para atuar na reabilitação física do paciente',
    cypressScheduleId: 'physiotherapist-schedule',
    cypressImmediateId: 'physiotherapist-immediate',
    cypressConsultationHelpId: 'physiotherapist-consultation-help',
  },
  FONOAUDIOLOGO: {
    title: 'Fonoaudiólogos',
    description:
      'Para ajudar a desenvolver a comunicação oral e escrita em crianças, jovens e adultos.',
    cypressScheduleId: 'speech-therapist-schedule',
    cypressImmediateId: 'speech-therapist-immediate',
    cypressConsultationHelpId: 'speech-therepist-consultation-help',
  },
  MEDICO: {
    title: 'Médicos',
    description:
      'Para cuidar da saúde por completo com clínicos gerais e especialistas.',
    cypressScheduleId: 'doctor-schedule',
    cypressImmediateId: 'doctor-immediate',
    cypressConsultationHelpId: 'doctor-consultation-help',
  },
  NUTRICIONISTA: {
    title: 'Nutricionistas',
    description: 'Para orientar sobre hábitos e alimentação saudáveis.',
    cypressScheduleId: 'nutritionist-schedule',
    cypressImmediateId: 'nutritionist-immediate',
    cypressConsultationHelpId: 'nutritionist-consultation-help',
  },
  PSICOLOGO: {
    title: 'Psicólogos',
    description: 'Para cuidar da saúde da mente e das emoções.',
    cypressScheduleId: 'psychologist-schedule',
    cypressImmediateId: 'psychologist-immediate',
    cypressConsultationHelpId: 'psychologist-consultation-help',
  },
  // PSICOLOGO_VIVA: '',
  EDUCADOR_FISICO: {
    title: 'Educador Físico',
    description: 'Para cuidar da saúde física e do bem-estar.',
    cypressScheduleId: 'physical-educator-schedule',
    cypressImmediateId: 'physical-educator-immediate',
    cypressConsultationHelpId: 'physical-educator-consultation-help',
  },
}

export const QUEUE_WAITING_TIME = 15
